import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { forwardRef, useState, useMemo, useLayoutEffect, createElement } from "react";
import { Vector2, Vector3, Color } from "three";
import { LineSegments2, LineMaterial, LineSegmentsGeometry } from "three-stdlib";

const LineSegment = /*#__PURE__*/ forwardRef(function LineSegment(_ref, ref) {
    let { points, color = "black", vertexColors, lineWidth, dashed } = _ref,
        rest = _objectWithoutPropertiesLoose(_ref, ["points", "color", "vertexColors", "lineWidth", "dashed"]);

    const [lineSegment2] = useState(() => new LineSegments2());
    const [lineMaterial] = useState(() => new LineMaterial());
    const [resolution] = useState(() => new Vector2(512, 512));
    const lineSegmentGeom = useMemo(() => {
        const geom = new LineSegmentsGeometry();
        const pValues = points.map((p) => (p instanceof Vector3 ? p.toArray() : p));
        geom.setPositions(pValues.flat());

        if (vertexColors) {
            const cValues = vertexColors.map((c) => (c instanceof Color ? c.toArray() : c));
            geom.setColors(cValues.flat());
        }

        return geom;
    }, [points, vertexColors]);
    useLayoutEffect(() => {
        lineSegment2.computeLineDistances();
    }, [points, lineSegment2]);
    useLayoutEffect(() => {
        if (dashed) {
            lineMaterial.defines.USE_DASH = "";
        } else {
            // Setting lineMaterial.defines.USE_DASH to undefined is apparently not sufficient.
            delete lineMaterial.defines.USE_DASH;
        }

        lineMaterial.needsUpdate = true;
    }, [dashed, lineMaterial]);
    return /*#__PURE__*/ createElement(
        "primitive",
        _extends(
            {
                dispose: undefined,
                object: lineSegment2,
                ref: ref,
            },
            rest,
        ),
        /*#__PURE__*/ createElement("primitive", {
            dispose: undefined,
            object: lineSegmentGeom,
            attach: "geometry",
        }),
        /*#__PURE__*/ createElement(
            "primitive",
            _extends(
                {
                    dispose: undefined,
                    object: lineMaterial,
                    attach: "material",
                    color: color,
                    vertexColors: Boolean(vertexColors),
                    resolution: resolution,
                    linewidth: lineWidth,
                    dashed: dashed,
                },
                rest,
            ),
        ),
    );
});

export { LineSegment };
